import React from 'react';
import { Link } from 'gatsby';

import Layout from '../components/layout';
import WorkProjects from '../components/WorkProjects';

const Work = () => (
	<Layout>
		<div className="flex" style={{marginLeft: '16px'}}>
			<Link className="p-3 mb-2" to="/">
				Back to home
			</Link>
		</div>
		<WorkProjects />
	</Layout>
);

export default Work;
